const setTitlesDisplay = (display) => {
    const rewardDescription = document.querySelector(".tl__cart-goal__reward-description__drawer");

    if (rewardDescription) {
        rewardDescription.style.display = display;
    }
};

const setUnreachedCheckpointIconBorderColor = (color) => {
    const allCheckpoints = document.querySelectorAll(".tl__cart-goal__goal-check-point__drawer");

    if (allCheckpoints.length) {
        allCheckpoints.forEach((e, index) => {
            if (index > window.tlCartGoalEmbed.passedMilestone.lastest) {
                e.style.borderColor = color;
            }
        });
    }
};

const removeItemText = () => {
    const allProductImageInfo = document.querySelectorAll(".tl__cart-goal__product-image-info");

    if (allProductImageInfo.length) {
        allProductImageInfo.forEach((container) => {
            const spans = container.querySelectorAll("span");
            const lastSpan = spans[spans.length - 1];

            if (lastSpan) {
                lastSpan.textContent = lastSpan.textContent.replace(/\s*item\s*/i, "").trim();
            }
        });
    }
};

const newRenderAllCartGoals = () => {
    let customRootElementCartPage = window.tlCartGoalEmbed.cartDisplay;
    let customRootElementCartDraw = window.tlCartGoalEmbed.cartDrawDisplay;

    if (document.querySelectorAll(".tl__cart-goal__container__drawer")) {
        document.querySelectorAll(".tl__cart-goal__container__drawer").forEach((ele) => ele.remove());
    }

    if (window.tlCartGoalEmbed.cartTotal === 0) {
        return;
    }

    // inject cart goals into cart drawer and cart page
    if (customRootElementCartPage.selector || customRootElementCartDraw.selector) {
        if (customRootElementCartPage.selector) {
            if (customRootElementCartPage.position === "prepend") {
                document.querySelectorAll(customRootElementCartPage.selector).forEach((ele, index) => {
                    let htmlObject = document.createElement("div");
                    htmlObject.classList.add("tl-custom-cart-goal-container");
                    htmlObject.innerHTML = window.tlCartGoalEmbed.renderCartGoal(index);
                    ele.prepend(htmlObject);
                });
            } else {
                let position = customRootElementCartPage.position === "before" ? "beforebegin" : "afterend";
                document
                    .querySelectorAll(customRootElementCartPage.selector)
                    .forEach((ele, index) => ele.insertAdjacentHTML(position, window.tlCartGoalEmbed.renderCartGoal(index)));
            }
        }
        if (customRootElementCartDraw.selector) {
            let position;
            if (customRootElementCartDraw.position === "prepend") {
                position = "prepend";
                document.querySelectorAll(customRootElementCartDraw.selector).forEach((ele, index) => {
                    let htmlObject = document.createElement("div");
                    htmlObject.classList.add("tl-custom-cart-goal-container");
                    htmlObject.innerHTML = window.tlCartGoalEmbed.renderCartGoal(index);
                    ele.prepend(htmlObject);
                });
            } else {
                position = customRootElementCartDraw.position === "before" ? "beforebegin" : "afterend";
                document
                    .querySelectorAll(customRootElementCartDraw.selector)
                    .forEach((ele, index) => ele.insertAdjacentHTML(position, window.tlCartGoalEmbed.renderCartGoal(index)));
            }
        }
    } else {
        if (window.tlCartGoalEmbed.cartTotal === 0) {
            window.tlCartGoalEmbed.ROOT_SELECTOR_POSITION = "beforebegin";
        }
        document.querySelectorAll(window.tlCartGoalEmbed.ROOT_SELECTOR_ELEMENT).forEach((ele, index) => {
            ele.insertAdjacentHTML(window.tlCartGoalEmbed.ROOT_SELECTOR_POSITION, window.tlCartGoalEmbed.renderCartGoal(index));
        });
    }

    setUnreachedCheckpointIconBorderColor("lightgray");
    removeItemText();

    window.tlCartGoalEmbed.addTrackImpressionEvent();
};

const newUpdateAllCartGoals = () => {
    if (window.tlCartGoalEmbed.cartTotal === 0) {
        const allCartGoals = document.querySelectorAll(".tl__cart-goal__container__drawer");

        if (allCartGoals.length) {
            allCartGoals.forEach((ele) => ele.remove());
        }

        return;
    }

    let cartGoalsContainerElements = document.querySelectorAll(".tl__cart-goal__container__drawer");
    if (cartGoalsContainerElements.length) {
        cartGoalsContainerElements.forEach((ele, index) => {
            let rewardsContainer = document.querySelector(`.tl__cart-goal__free-gift-container-${index}`);
            if (rewardsContainer) {
                rewardsContainer.innerHTML = window.tlCartGoalEmbed.updateCartGoal(index);
            }
        });
    } else {
        window.tlCartGoalEmbed.renderAllCartGoals();
    }
};

document.addEventListener("DOMContentLoaded", () => {
    const intervalId = setInterval(() => {
        const completedSteps = {
            embed: false,
            progressBar: false,
            popup: false,
        };

        if (!completedSteps.embed) {
            if (window.tlFreeGiftBlock) {
                window.tlFreeGiftBlock.handleClaimGifts = () => {};
                window.tlFreeGiftBlock.handleAutoAdd = () => {};
                window.tlFreeGiftBlock.handleAutoRemove = () => {};
                window.tlFreeGiftBlock.moneyFormat = window.tlFreeGiftBlock.moneyFormat.replace(/{{(.*?)}}/g, `{{amount_no_decimals}}`);

                setTimeout(() => {
                    window.tlFreeGiftBlock.updateCartData = () => {};
                }, 1000);
            }

            completedSteps.embed = true;
        }

        if (!completedSteps.popup) {
            if (window.tlAdvancedFreeGift) {
                if (window.tlCartGoalEmbed && Object.keys(window.tlCartGoalEmbed.cartGoal).length) {
                    const handleCartGoalEvent = async () => {
                        await window.tlCartGoalEmbed.updateCartTotal();
                    };

                    window.addEventListener("TLADVANCEDFG:add", handleCartGoalEvent);
                    window.addEventListener("TLADVANCEDFG:change", handleCartGoalEvent);
                    window.addEventListener("TLADVANCEDFG:update", handleCartGoalEvent);
                }
            }

            completedSteps.popup = true;
        }

        if (!completedSteps.progressBar) {
            if (window.tlCartGoalEmbed && Object.keys(window.tlCartGoalEmbed.cartGoal).length) {
                if (window.tlAdvancedFreeGift) {
                    const handlePopupEvent = async () => {
                        await window.tlAdvancedFreeGift.updateCartData();
                        window.tlCartGoalEmbed.updateCartTotal();
                    };

                    window.addEventListener("TLCARTGOAL:add", handlePopupEvent);
                    window.addEventListener("TLCARTGOAL:change", handlePopupEvent);
                    window.addEventListener("TLCARTGOAL:update", handlePopupEvent);
                }

                window.tlCartGoalEmbed.renderAllCartGoals = newRenderAllCartGoals;
                window.tlCartGoalEmbed.updateAllCartGoals = newUpdateAllCartGoals;

                window.tlCartGoalEmbed.updateCartTotal();

                if (window.location.pathname === "/cart") {
                    const cartDrawer = document.querySelector("cart-drawer#cart-drawer");

                    if (cartDrawer) {
                        cartDrawer.remove();
                    }
                } else {
                    const target = document.querySelector("#cart-drawer");

                    if (target) {
                        const observer = new MutationObserver(() => {
                            if (!target.querySelector(".tl__cart-goal__container__drawer")) {
                                observer.disconnect();

                                window.tlCartGoalEmbed.updateAllCartGoals();

                                setTimeout(() => {
                                    observer.observe(target, { childList: true, subtree: true });
                                }, 250);
                            }
                        });

                        observer.observe(target, { childList: true, subtree: true });
                    }
                }
            }

            completedSteps.progressBar = true;
        }

        if (completedSteps.embed && completedSteps.progressBar && completedSteps.popup) {
            clearInterval(intervalId);
            console.log("✅ All customizations done!");
        }
    }, 50);

    setTimeout(() => {
        clearInterval(intervalId);
    }, 5000);
});
